import { render, staticRenderFns } from "./CompaniesSettings.vue?vue&type=template&id=72e166de&scoped=true"
import script from "./CompaniesSettings.vue?vue&type=script&lang=js"
export * from "./CompaniesSettings.vue?vue&type=script&lang=js"
import style0 from "./CompaniesSettings.vue?vue&type=style&index=0&id=72e166de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e166de",
  null
  
)

export default component.exports